export default function ComponentBlocksTextSideBySide ({ TextGroups }) {
  return (
    <div className="col-12">
      <div className="row gx-lg-5 gy-4 gy-lg-0">
        {
          TextGroups.map((TextGroup, index) => (
            <div
              key={index}
              className="col-12 col-lg-6"
            >
              <h3 className="text-dark">{TextGroup.Title}</h3>
              <div dangerouslySetInnerHTML={{ __html: TextGroup.Content }}></div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
